import moment from 'moment';
import AdminService from "external-services/diary-admin-service/admin.service";
import {IThemeValue} from "shared-types/index";

const NS = 'UrlGeneratorService';

interface IConfig {
	widgetV2Url: string;
	widgetUrl: string;
}


class UrlGeneratorService {

  private accountId: string;
  private venueId: number;

  private config: any; // from window.config

  private customTheme: IThemeValue;

  setup(accountId: string, venueId: number, config: any, customTheme?: IThemeValue): void {
    this.accountId = accountId;
    this.venueId = venueId;
    this.config = config;
    this.customTheme = customTheme;
  }


  generateBookingUrl(bookingId: string, forceWidgetV2Url = false) {

    const theme = this.customTheme || AdminService.getThemeValues();
    const isUsingWidgetV2 = forceWidgetV2Url || theme.widgetVersion === 2;
    
    let paymentUrl = isUsingWidgetV2 ? this.config.widgetV2Url : this.config.widgetUrl + 'booking';

  	paymentUrl += `?accountid=${this.accountId}`
      + (theme.theme ? `&theme=${theme.theme}` : '')
      + (theme.accentColour ? `&accent=${theme.accentColour}` : '')
  		+ `&venueid=${this.venueId}`
  		+ (theme.font ? `&font=${theme.font}` : '')
  		+ `&bookingid=${bookingId}`;

  	paymentUrl = encodeURI(paymentUrl.trim()); // encoding the url to fix the issue with multiple words in the url

  	return paymentUrl;
  }

  generateEventUrl(date: Date, eventId: string, isPrivateFunction: boolean) {

    const theme = AdminService.getThemeValues();
    const isUsingWidgetV2 = theme.widgetVersion === 2;
    const widgetUrl = isUsingWidgetV2 ? this.config.widgetV2Url : this.config.widgetUrl;

    let paymentUrl = widgetUrl + (
      isPrivateFunction ? 'payment' : (isUsingWidgetV2 ? '' : 'booking')
    );

    const mDate = moment(date).format('YYYY-MM-DD');

  	paymentUrl += `?accountid=${this.accountId}`
      + (theme.theme ? `&theme=${theme.theme}` : '')
      + (theme.accentColour ? `&accent=${theme.accentColour}` : '')
  		+ `&venueid=${this.venueId}`
  		+ (theme.font ? `&font=${theme.font}` : '')
  		+ `&date=${mDate}`
  		+ `&serviceids=${eventId}`;

  	paymentUrl = encodeURI(paymentUrl.trim()); // encoding the url to fix the issue with multiple words in the url

  	return paymentUrl;
  }


}


// creates a singleton instance to export
const instance = new UrlGeneratorService();
export { instance as UrlGeneratorService };
